module.exports = __webpack_public_path__ + "static/media/groceries.a3c03d89.jpg";